import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperPreview: {
      display: "flex",
      justifyContent: "space-between",
    },
    containerItems: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      width: "100%",
      padding: "0px 24px 0px 0px",
    },
    containerMainItem: {
      height: "547px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
    },
    conatinerPlayPauseIcon: {
      position: "absolute",
      borderRadius: "999999px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      background: "rgba(0, 0, 0, 0.4)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
    },
    containerSubItemsSection: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      alignItems: "center",
      width: "100%",
      justifyContent: "center",
    },
    containerNextPrevButton: {
      border: `1px solid ${theme.palette.background.gray_200}`,
      padding: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "99999px",
      height: "36px",
      width: "36px",
    },
    videoThumbnailsContainer: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      overflowX: "auto",
      scrollBehavior: "smooth",
      maxWidth: "400px",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    videoThumbnailWrapper: {
      height: "110px",
      width: "114.66667175292969px",
      flex: "0 0 auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
    },
  };
});
